import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import NombreBien from './NombreBien';

interface NombreBienTableProps {
  data: NombreBien[];
  columns: TableColumn<NombreBien>[];
  customStyles: Record<string, any>;
}

const NombreBienTable: React.FC<NombreBienTableProps> = ({ data, columns, customStyles }) => {
  return (
    <DataTable<NombreBien>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent={"No hay registros para mostrar."}
    />
  );
};

export default NombreBienTable;